import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DeleteDispatchIssueDocumentInput,
  DeleteDispatchIssueDocumentBulkResponse,
  MutationDeleteDispatchIssueDocumentBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteDispatchIssueDocument } from '@/features/IssueHistory/api/queries/DeleteDispatchIssueDocument';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteDispatchIssueDocumentInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteDispatchIssueDocumentBulkResponse>;
}

// DeleteDispatchIssueDocument Service
export const { deleteDispatchIssueDocument, useDeleteDispatchIssueDocument } = ((): {
  deleteDispatchIssueDocument: ServiceMethod;
  useDeleteDispatchIssueDocument: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteDispatchIssueDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: DeleteDispatchIssueDocumentInput[],
        options?: ConnectionOptions
      ): Promise<DeleteDispatchIssueDocumentBulkResponse> => {
        const args: MutationDeleteDispatchIssueDocumentBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteDispatchIssueDocumentBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteDispatchIssueDocumentBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteDispatchIssueDocument: fetch,
    useDeleteDispatchIssueDocument: useService,
  };
})();
